import { IColumn } from '../components';
import { TFunction } from 'i18next';

export const LocalizedColumns = (columns: IColumn[], t: TFunction, isEmptyKpi?: boolean) => {
  return columns.map((column) => ({
    ...column,
    name: column.id ? (isEmptyKpi && column.id === 'kpi' ? '' : t(`columns.${column.id}`)) : '',
  }));
};
